import React from 'react';
import { Table } from 'react-bootstrap';

const AccountTable = () => {
  const data = [
    {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/1/23",
        reference: "",
        jrnl: "",
        transDescription: "Beginning Balance",
        debitAmt: "",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/4/23",
        reference: "0003",
        jrnl: "SJ",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT",
        debitAmt: "153,000,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/5/23",
        reference: "0004",
        jrnl: "SJ",
        transDescription: "SHIRORO",
        debitAmt: "30,000,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/5/23",
        reference: "0005",
        jrnl: "SJ",
        transDescription: "DASMIDAM ENTERPRISES",
        debitAmt: "45,000,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/5/23",
        reference: "0006",
        jrnl: "SJ",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT",
        debitAmt: "76,500,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/6/23",
        reference: "0007",
        jrnl: "SJ",
        transDescription: "GHAZZALI MUSA",
        debitAmt: "32,500,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/6/23",
        reference: "0008",
        jrnl: "SJ",
        transDescription: "CHANLIN MOTORCY",
        debitAmt: "88,632,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/9/23",
        reference: "0009",
        jrnl: "SJ",
        transDescription: "ALORAL ENTERPRISES",
        debitAmt: "60,000,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/11/23",
        reference: "0010",
        jrnl: "SJ",
        transDescription: "PENGHAO GAO",
        debitAmt: "72,270,600.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/12/23",
        reference: "0011",
        jrnl: "SJ",
        transDescription: "JOVI GLOBAL",
        debitAmt: "124,034,400.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/15/23",
        reference: "0012",
        jrnl: "SJ",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT",
        debitAmt: "285,870,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/18/23",
        reference: "0013",
        jrnl: "SJ",
        transDescription: "Y.U.K AGRO",
        debitAmt: "532,440,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/19/23",
        reference: "0014",
        jrnl: "SJ",
        transDescription: "JOVI GLOBAL",
        debitAmt: "211,471,500.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/22/23",
        reference: "0015",
        jrnl: "SJ",
        transDescription: "SHIRORO",
        debitAmt: "182,179,800.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/24/23",
        reference: "0016",
        jrnl: "SJ",
        transDescription: "ALGORATU",
        debitAmt: "325,535,050.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "",
        reference: "",
        jrnl: "",
        transDescription: "Current Period Change",
        debitAmt: "2,219,433,350.00",
        creditAmt: "",
        balance: "2,219,433,350.00"
      },
      {
        accountId: 1100,
        accountDescription: "Accounts Receivable",
        date: "1/31/23",
        reference: "",
        jrnl: "",
        transDescription: "Ending Balance",
        debitAmt: "",
        creditAmt: "",
        balance: "2,219,433,350.00"
      },
      {
        accountId: 1200,
        accountDescription: "Inventory",
        date: "1/1/23",
        reference: "",
        jrnl: "",
        transDescription: "Beginning Balance",
        debitAmt: "",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 1200,
        accountDescription: "Inventory",
        date: "1/4/23",
        reference: "0001",
        jrnl: "PJ",
        transDescription: "USMAN MAI - Item: 001 - MAIZE",
        debitAmt: "100,000,001.50",
        creditAmt: "",
        balance: ""
      },
        // Inventory Transactions
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/1/23",
          reference: "",
          jrnl: "",
          transDescription: "Beginning Balance",
          debitAmt: "",
          creditAmt: "",
          balance: "0"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/4/23",
          reference: "0001",
          jrnl: "PJ",
          transDescription: "USMAN MAI - Item: 001 - MAIZE",
          debitAmt: "100,000,001.50",
          creditAmt: "",
          balance: "100,000,001.50"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/4/23",
          reference: "0016",
          jrnl: "PJ",
          transDescription: "MAGAJI SH - Item: 002 - PADDY RICE",
          debitAmt: "153,516,000.00",
          creditAmt: "",
          balance: "153,516,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/4/23",
          reference: "0003",
          jrnl: "COGS",
          transDescription: "WEIHE MULTI GLOBAL INVESTMENT - Item: 002 - PADDY RICE",
          debitAmt: "",
          creditAmt: "135,000,000.00",
          balance: "-135,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/5/23",
          reference: "002",
          jrnl: "PJ",
          transDescription: "Y.U.K AGRO - Item: 002 - PADDY RICE",
          debitAmt: "105,000,000.00",
          creditAmt: "",
          balance: "105,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/5/23",
          reference: "0003",
          jrnl: "PJ",
          transDescription: "IBRAHIM AB - Item: 004 - CORN",
          debitAmt: "31,114,490.00",
          creditAmt: "",
          balance: "31,114,490.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/5/23",
          reference: "0004",
          jrnl: "PJ",
          transDescription: "MAGAJI SH - Item: 006 - HABISCUS",
          debitAmt: "50,000,000.00",
          creditAmt: "",
          balance: "50,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/5/23",
          reference: "0004",
          jrnl: "COGS",
          transDescription: "SHIRORO - Item: 004 - CORN",
          debitAmt: "",
          creditAmt: "22,550,000.00",
          balance: "-22,550,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/5/23",
          reference: "0005",
          jrnl: "COGS",
          transDescription: "DASMIDAM ENTERPRISES - Item: 005 - WHEAT",
          debitAmt: "",
          creditAmt: "35,000,000.00",
          balance: "-35,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/5/23",
          reference: "0006",
          jrnl: "COGS",
          transDescription: "WEIHE MULTI GLOBAL INVESTMENT - Item: 002 - PADDY RICE",
          debitAmt: "",
          creditAmt: "67,500,000.00",
          balance: "-67,500,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/6/23",
          reference: "0007",
          jrnl: "COGS",
          transDescription: "GHAZZALI MUSA - Item: 001 - MAIZE",
          debitAmt: "",
          creditAmt: "17,500,000.00",
          balance: "-17,500,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/6/23",
          reference: "0008",
          jrnl: "COGS",
          transDescription: "CHANLIN MOTORCY - Item: 006 - HABISCUS",
          debitAmt: "",
          creditAmt: "59,088,000.00",
          balance: "-59,088,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/8/23",
          reference: "0005",
          jrnl: "PJ",
          transDescription: "IBRAHIM AB - Item: 005 - WHEAT",
          debitAmt: "140,000,000.00",
          creditAmt: "",
          balance: "140,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/8/23",
          reference: "0006",
          jrnl: "PJ",
          transDescription: "OLADIPOMOD - Item: 002 - PADDY RICE",
          debitAmt: "105,000,000.00",
          creditAmt: "",
          balance: "105,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/9/23",
          reference: "0009",
          jrnl: "COGS",
          transDescription: "ALORAL ENTERPRISES - Item: 004 - CORN",
          debitAmt: "",
          creditAmt: "45,100,000.00",
          balance: "-45,100,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/11/23",
          reference: "0006",
          jrnl: "PJ",
          transDescription: "USMAN MAI - Item: 004 - CORN",
          debitAmt: "90,651,000.00",
          creditAmt: "",
          balance: "90,651,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/11/23",
          reference: "0010",
          jrnl: "COGS",
          transDescription: "PENGHAO GAO - Item: 004 - CORN",
          debitAmt: "",
          creditAmt: "54,323,401.00",
          balance: "-54,323,401.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/12/23",
          reference: "0007",
          jrnl: "PJ",
          transDescription: "SADTEX CLEARING & FORWARDING L - Item: 001 - MAIZE",
          debitAmt: "105,000,000.00",
          creditAmt: "",
          balance: "105,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/12/23",
          reference: "0008",
          jrnl: "PJ",
          transDescription: "NURA ALI - Item: 004 - CORN",
          debitAmt: "22,550,000.00",
          creditAmt: "",
          balance: "22,550,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/12/23",
          reference: "0011",
          jrnl: "COGS",
          transDescription: "JOVI GLOBAL - Item: 005 - WHEAT",
          debitAmt: "",
          creditAmt: "96,471,200.00",
          balance: "-96,471,200.00"
        },
        {accountId: 1200,
          accountDescription: "Inventory",
          date: "1/15/23",
          reference: "0012",
          jrnl: "COGS",
          transDescription: "WEIHE MULTI GLOBAL INVESTMENT - Item: 001 - MAIZE",
          debitAmt: "",
          creditAmt: "153,930,000.00",
          balance: "-153,930,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/16/23",
          reference: "0009",
          jrnl: "PJ",
          transDescription: "SADTEX CLEARING & FORWARDING L - Item: 006 - HABISCUS",
          debitAmt: "120,000,000.00",
          creditAmt: "",
          balance: "120,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/17/23",
          reference: "0010",
          jrnl: "PJ",
          transDescription: "Y.U.K AGRO - Item: 006 - HABISCUS",
          debitAmt: "250,000,000.00",
          creditAmt: "",
          balance: "250,000,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/18/23",
          reference: "0011",
          jrnl: "PJ",
          transDescription: "JARKASA - Item: 005 - WHEAT",
          debitAmt: "81,200,000.00",
          creditAmt: "",
          balance: "81,200,000.00"
        },
        {
          accountId: 1200,
          accountDescription: "Inventory",
          date: "1/19/23",
          reference: "0012",
          jrnl: "PJ",
          transDescription: "SHIRORO - Item: 002 - PADDY RICE",
          debitAmt: "107,100,000.00",
          creditAmt: "",
          balance: "107,100,000.00"
        }, {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/1/23",
            reference: "",
            jrnl: "",
            transDescription: "Beginning Balance",
            debitAmt: "",
            creditAmt: "",
            balance: "0.00"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/4/23",
            reference: "0001",
            jrnl: "PJ",
            transDescription: "USMAN MAI",
            debitAmt: "",
            creditAmt: "100,000,001.50",
            balance: "100,000,001.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/4/23",
            reference: "0016",
            jrnl: "PJ",
            transDescription: "MAGAJI SH",
            debitAmt: "",
            creditAmt: "153,516,000.00",
            balance: "253,516,001.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/5/23",
            reference: "002",
            jrnl: "PJ",
            transDescription: "Y.U.K AGRO",
            debitAmt: "",
            creditAmt: "105,000,000.00",
            balance: "358,516,001.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/5/23",
            reference: "0003",
            jrnl: "PJ",
            transDescription: "IBRAHIM AB",
            debitAmt: "",
            creditAmt: "31,114,490.00",
            balance: "389,630,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/5/23",
            reference: "0004",
            jrnl: "PJ",
            transDescription: "MAGAJI SH",
            debitAmt: "",
            creditAmt: "50,000,000.00",
            balance: "439,630,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/8/23",
            reference: "0005",
            jrnl: "PJ",
            transDescription: "IBRAHIM AB",
            debitAmt: "",
            creditAmt: "140,000,000.00",
            balance: "579,630,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/8/23",
            reference: "0006",
            jrnl: "PJ",
            transDescription: "OLADIPOMOD",
            debitAmt: "",
            creditAmt: "105,000,000.00",
            balance: "684,630,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/11/23",
            reference: "0006",
            jrnl: "PJ",
            transDescription: "USMAN MAI",
            debitAmt: "",
            creditAmt: "90,651,000.00",
            balance: "775,281,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/12/23",
            reference: "0007",
            jrnl: "PJ",
            transDescription: "SADTEX CLEARING & FORWARDING L",
            debitAmt: "",
            creditAmt: "105,000,000.00",
            balance: "880,281,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/12/23",
            reference: "0008",
            jrnl: "PJ",
            transDescription: "NURA ALI",
            debitAmt: "",
            creditAmt: "22,550,000.00",
            balance: "902,831,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/16/23",
            reference: "0009",
            jrnl: "PJ",
            transDescription: "SADTEX CLEARING & FORWARDING L",
            debitAmt: "",
            creditAmt: "120,000,000.00",
            balance: "1,022,831,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/17/23",
            reference: "0010",
            jrnl: "PJ",
            transDescription: "Y.U.K AGRO",
            debitAmt: "",
            creditAmt: "250,000,000.00",
            balance: "1,272,831,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/18/23",
            reference: "0011",
            jrnl: "PJ",
            transDescription: "JARKASA",
            debitAmt: "",
            creditAmt: "81,200,000.00",
            balance: "1,354,031,491.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/18/23",
            reference: "0013",
            jrnl: "PJ",
            transDescription: "BIN WANG",
            debitAmt: "",
            creditAmt: "20,520,500.00",
            balance: "1,374,551,991.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/22/23",
            reference: "0012",
            jrnl: "PJ",
            transDescription: "Y.U.K AGRO",
            debitAmt: "",
            creditAmt: "285,000,000.00",
            balance: "1,659,551,991.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/22/23",
            reference: "0012",
            jrnl: "PJ",
            transDescription: "NURA ALI",
            debitAmt: "",
            creditAmt: "124,600,000.00",
            balance: "1,784,151,991.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/23/23",
            reference: "0014",
            jrnl: "PJ",
            transDescription: "Y.U.K AGRO",
            debitAmt: "",
            creditAmt: "82,500,000.00",
            balance: "1,866,651,991.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/24/23",
            reference: "0015",
            jrnl: "PJ",
            transDescription: "JARKASA",
            debitAmt: "",
            creditAmt: "30,100,000.00",
            balance: "1,896,751,991.50"
          },
          {
            accountId: 2000,
            accountDescription: "Accounts Payable",
            date: "1/31/23",
            reference: "",
            jrnl: "",
            transDescription: "Ending Balance",
            debitAmt: "",
            creditAmt: "-1,896,751,991.50",
            balance: "-1,896,751,991.50"
          },
          
          // Beginning Balance Equity Transactions
          {
            accountId: 3909,
            accountDescription: "Beginning Balance Equity",
            date: "1/1/23",
            reference: "",
            jrnl: "",
            transDescription: "Beginning Balance",
            debitAmt: "",
            creditAmt: "",
            balance: "0.00"
          },
          {
            accountId: 3909,
            accountDescription: "Beginning Balance Equity",
            date: "1/1/23",
            reference: "BEGBAL",
            jrnl: "GENJ",
            transDescription: "Initial Equity Balance",
            debitAmt: "",
            creditAmt: "1,000,000.00",
            balance: "1,000,000.00"
          },
          {
            accountId: 3909,
            accountDescription: "Beginning Balance Equity",
            date: "1/31/23",
            reference: "",
            jrnl: "",
            transDescription: "Ending Balance",
            debitAmt: "",
            creditAmt: "1,000,000.00",
            balance: "1,000,000.00"
          },
        
          // Share Capital Transactions
          {
            accountId: 3911,
            accountDescription: "Share capital",
            date: "1/1/23",
            reference: "",
            jrnl: "",
            transDescription: "Beginning Balance",
            debitAmt: "",
            creditAmt: "",
            balance: "0.00"
          },
          {
            accountId: 3911,
            accountDescription: "Share capital",
            date: "1/1/23",
            reference: "BEGBAL",
            jrnl: "GENJ",
            transDescription: "Initial Share Capital",
            debitAmt: "",
            creditAmt: "1,000,000.00",
            balance: "1,000,000.00"
          },
          {
            accountId: 3911,
            accountDescription: "Share capital",
            date: "1/31/23",
            reference: "",
            jrnl: "",
            transDescription: "Ending Balance",
            debitAmt: "",
            creditAmt: "-1,000,000.00",
            balance: "0.00"
          },
      
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/1/23",
        reference: "",
        jrnl: "Beginning Balance",
        transDescription: "",
        debitAmt: "",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/4/23",
        reference: "0003",
        jrnl: "SJ",
        transDescription: "WEIHE MULTI GLOBAL",
        debitAmt: "153,000,000.00",
        creditAmt: "",
        balance: "153,000,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/5/23",
        reference: "0004",
        jrnl: "SJ",
        transDescription: "SHIRORO",
        debitAmt: "30,000,000.00",
        creditAmt: "",
        balance: "183,000,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/5/23",
        reference: "0005",
        jrnl: "SJ",
        transDescription: "DASMIDAM ENTERPRISES",
        debitAmt: "45,000,000.00",
        creditAmt: "",
        balance: "228,000,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/5/23",
        reference: "0006",
        jrnl: "SJ",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT",
        debitAmt: "76,500,000.00",
        creditAmt: "",
        balance: "304,500,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/6/23",
        reference: "0007",
        jrnl: "SJ",
        transDescription: "GHAZZALI MUSA",
        debitAmt: "32,500,000.00",
        creditAmt: "",
        balance: "337,000,000.00"
        },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/6/23",
        reference: "0008",
        jrnl: "SJ",
        transDescription: "CHANLIN MOTORCY",
        debitAmt: "88,632,000.00",
        creditAmt: "",
        balance: "425,632,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/9/23",
        reference: "0009",
        jrnl: "SJ",
        transDescription: "ALORAL ENTERPRISES",
        debitAmt: "60,000,000.00",
        creditAmt: "",
        balance: "485,632,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/11/23",
        reference: "0010",
        jrnl: "SJ",
        transDescription: "PENGHAO GAO",
        debitAmt: "72,270,600.00",
        creditAmt: "",
        balance: "557,902,600.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/12/23",
        reference: "0011",
        jrnl: "SJ",
        transDescription: "JOVI GLOBAL",
        debitAmt: "124,034,400.00",
        creditAmt: "",
        balance: "681,937,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/15/23",
        reference: "0012",
        jrnl: "SJ",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT",
        debitAmt: "285,870,000.00",
        creditAmt: "",
        balance: "967,807,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/18/23",
        reference: "0013",
        jrnl: "SJ",
        transDescription: "Y.U.K AGRO",
        debitAmt: "532,440,000.00",
        creditAmt: "",
        balance: "1,500,247,000.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/19/23",
        reference: "0014",
        jrnl: "SJ",
        transDescription: "JOVI GLOBAL",
        debitAmt: "211,471,500.00",
        creditAmt: "",
        balance: "1,711,718,500.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/22/23",
        reference: "0015",
        jrnl: "SJ",
        transDescription: "SHIRORO",
        debitAmt: "182,179,800.00",
        creditAmt: "",
        balance: "1,893,898,300.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/24/23",
        reference: "0016",
        jrnl: "SJ",
        transDescription: "ALGORATU",
        debitAmt: "325,535,050.00",
        creditAmt: "",
        balance: "2,219,433,350.00"
      },
      {
        accountId: 4000,
        accountDescription: "Sales Income",
        date: "1/31/23",
        reference: "",
        jrnl: "Ending Balance",
        transDescription: "",
        debitAmt: "",
        creditAmt: "",
        balance: "2,219,433,350.00"
      },{
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/1/23",
        reference: "",
        jrnl: "",
        transDescription: "Beginning Balance",
        debitAmt: "",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/4/23",
        reference: "0003",
        jrnl: "COGS",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT - Item: 002 - PADDY RICE",
        debitAmt: "135,000,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/5/23",
        reference: "0004",
        jrnl: "COGS",
        transDescription: "SHIRORO - Item: 004 - CORN",
        debitAmt: "22,550,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/5/23",
        reference: "0005",
        jrnl: "COGS",
        transDescription: "DASMIDAM ENTERPRISES - Item: 005 - WHEAT",
        debitAmt: "35,000,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/5/23",
        reference: "0006",
        jrnl: "COGS",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT - Item: 002 - PADDY RICE",
        debitAmt: "67,500,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/6/23",
        reference: "0007",
        jrnl: "COGS",
        transDescription: "GHAZZALI MUSA - Item: 001 - MAIZE",
        debitAmt: "17,500,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/6/23",
        reference: "0008",
        jrnl: "COGS",
        transDescription: "CHANLIN MOTORCY - Item: 006 - HABISCUS",
        debitAmt: "59,088,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/9/23",
        reference: "0009",
        jrnl: "COGS",
        transDescription: "ALORAL ENTERPRISES - Item: 004 - CORN",
        debitAmt: "45,100,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/11/23",
        reference: "0010",
        jrnl: "COGS",
        transDescription: "PENGHAO GAO - Item: 004 - CORN",
        debitAmt: "54,323,401.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/12/23",
        reference: "0011",
        jrnl: "COGS",
        transDescription: "JOVI GLOBAL - Item: 005 - WHEAT",
        debitAmt: "96,471,200.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/15/23",
        reference: "0012",
        jrnl: "COGS",
        transDescription: "WEIHE MULTI GLOBAL INVESTMENT - Item: 001 - MAIZE",
        debitAmt: "153,930,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/18/23",
        reference: "0013",
        jrnl: "COGS",
        transDescription: "Y.U.K AGRO - Item: 002 - PADDY RICE",
        debitAmt: "469,800,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/19/23",
        reference: "0014",
        jrnl: "COGS",
        transDescription: "JOVI GLOBAL - Item: 006 - HABISCUS",
        debitAmt: "140,981,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/22/23",
        reference: "0015",
        jrnl: "COGS",
        transDescription: "SHIRORO - Item: 005 - WHEAT",
        debitAmt: "141,695,400.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/24/23",
        reference: "0016",
        jrnl: "COGS",
        transDescription: "ALGORATU - Item: 001 - MAIZE",
        debitAmt: "11,700,850.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/24/23",
        reference: "0016",
        jrnl: "COGS",
        transDescription: "ALGORATU - Item: 006 - HABISCUS",
        debitAmt: "120,909,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/24/23",
        reference: "0016",
        jrnl: "COGS",
        transDescription: "ALGORATU - Item: 004 - CORN",
        debitAmt: "23,045,649.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/24/23",
        reference: "0016",
        jrnl: "COGS",
        transDescription: "ALGORATU - Item: 005 - WHEAT",
        debitAmt: "71,386,000.00",
        creditAmt: "",
        balance: ""
      },
      {
        accountId: 5000,
        accountDescription: "Cost of Sales",
        date: "1/31/23",
        reference: "",
        jrnl: "",
        transDescription: "Ending Balance",
        debitAmt: "",
        creditAmt: "",
        balance: "1,665,980,500.00"
      }
      
                                           
    
  ];

  return (
    <div className="container-fluid mt-4">
      <h3 className="text-center">Katsina State Government General Ledger</h3>
      <h3 className="text-center">
        For the Period From Jan 1, 2023 to Jan 31, 2023
      </h3>
      <Table bordered hover responsive striped>
        <thead className="thead-dark">
          <tr>
            <th>Account ID</th>
            <th>Account Description</th>
            <th>Date</th>
            <th>Reference</th>
            <th>Journal</th>
            <th>Transaction Description</th>
            <th>Debit Amount</th>
            <th>Credit Amount</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.accountId}</td>
              <td>{row.accountDescription}</td>
              <td>{row.date}</td>
              <td>{row.reference}</td>
              <td>{row.journal}</td>
              <td>{row.transDescription}</td>
              <td
                style={{ textAlign: "right", fontWeight: "bold" }}
                className="text-bold"
              >
                {row.debitAmt || "-"}
              </td>
              <td
                style={{ textAlign: "right", fontWeight: "bold" }}
                className="text-bold"
              >
                {row.creditAmt || "-"}
              </td>
              <td
                style={{ textAlign: "right", fontWeight: "bold" }}
                className="text-bold"
              >
                {row.balance}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AccountTable;